import type { ResourceProps } from 'react-admin';
import { CanAccess } from 'react-admin';
import { type ComponentType, lazy } from 'react';
import { resources } from '@repo/c360-ra-components';

const AsyncPageList = lazy(() => import('./list'));
const AsyncPageShow = lazy(() => import('./show'));

const ProtectedList = () => (
  <CanAccess resource={resources.manualMerges} action="list">
    <AsyncPageList />
  </CanAccess>
);

const ProtectedShow = () => (
  <CanAccess resource={resources.manualMerges} action="show">
    <AsyncPageShow />
  </CanAccess>
);

export default {
  list: ProtectedList as ComponentType<any>,
  show: ProtectedShow as ComponentType<any>,
} as ResourceProps;
